import { render, staticRenderFns } from "./SocialSpain.vue?vue&type=template&id=6305dfad&scoped=true&"
import script from "./SocialSpain.vue?vue&type=script&lang=js&"
export * from "./SocialSpain.vue?vue&type=script&lang=js&"
import style0 from "./SocialSpain.vue?vue&type=style&index=0&id=6305dfad&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6305dfad",
  null
  
)

export default component.exports